/**
 * vue 全局过滤器
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

import {
  invoiceCheckStatus,
  invoiceReimbursementStatus,
  invoiceUsedStatus,
  invoiceHasTitle,
  invoiceStatus,
  discernStatus,
  invoiceExtractStatus,
  invoiceFlag,
  redFlag,
  SignFlag,
} from './const';

import { dateFormat } from 'vux';
import {companySource} from "./common";

export default {
  /** 格式化时间为指定格式
   * @param  time 时间字符串
   * @param  fmt  格式
   */
  formatDateTime(time, fmt) {
    if (time) {
      time = time.replace(/-/g, '/');
      return dateFormat(time, fmt); //new Date(time).format(fmt);
      //return window.localUtils.fmtDate(new Date(time), fmt);
    } else {
      return time;
    }
  },

  /** 格式化标题   控制字数
   * @param  value 文本
   * @param  leng  保留长度
   */
  formatTitle(value, leng) {
    var rel = '';
    if (value && value.length > leng) {
      rel = value.substr(0, leng);
    } else {
      rel = value;
    }
    return rel;
  },

  /** 格式化  格式化时间  友好格式  如 刚刚 一分钟前
   * @param  time 时间 字符串
   * @param  fmt  要格式化的格式
   */
  //格式化时间  友好格式  如 刚刚 一分钟前
  friendlyTime(time, fmt) {
    var date = typeof time === 'number' ? new Date(time) : new Date((time || '').replace(/-/g, '/'));
    var diff = (new Date().getTime() - date.getTime()) / 1000;
    var dayDiff = Math.floor(diff / 86400);

    var isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());

    if (!isValidDate) {
      console.error('not a valid date');
    }
    const formatDate = function(date) {
      var today = new Date(date);
      var year = today.getFullYear();
      var month = ('0' + (today.getMonth() + 1)).slice(-2);
      var day = ('0' + today.getDate()).slice(-2);
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    };

    if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
      //return formatDate(date)
      return new Date(date).format(fmt);
    }

    return (
      (dayDiff === 0 &&
        ((diff < 60 && '刚刚') ||
          (diff < 120 && '1分钟前') ||
          (diff < 3600 && Math.floor(diff / 60) + '分钟前') ||
          (diff < 7200 && '1小时前') ||
          (diff < 86400 && Math.floor(diff / 3600) + '小时前'))) ||
      (dayDiff === 1 && '昨天') ||
      (dayDiff < 7 && dayDiff + '天前') ||
      (dayDiff < 31 && Math.ceil(dayDiff / 7) + '周前')
    );
  },

  /** 格式化  识别状态
   * @param  value 识别状态
   * @param  $t i10n国际化对象
   */
  formatDiscernStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case discernStatus.notDiscern:
      case discernStatus.notDiscern + '':
        rel = '<span class="document-mark">' + $t('待识别') + '</span>';
        // rel =
        //   '<span class="document-mark primary">' + $t("识别中") + "</span>";

        break;
      case discernStatus.discerning:
      case discernStatus.discerning + '':
        rel = '<span class="document-mark primary">' + $t('识别中') + '</span>';
        break;

      case discernStatus.discernSuccess:
      case discernStatus.discernSuccess + '':
        rel = '<span class="document-mark success">' + $t('识别完成') + '</span>';
        break;

      default:
      case discernStatus.discernFailed:
      case discernStatus.discernFailed + '':
        rel = '<span class="document-mark error">' + $t('识别失败') + '</span>';
        break;
    }
    return rel;
  },

  /** 格式化  验真状态
   * @param  value 验真状态
   * @param  $t i10n国际化对象
   */
  formatCheckStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceCheckStatus.checkSuccess:
      case invoiceCheckStatus.checkSuccess + '':
        rel = '<span class="document-mark success">' + $t('验真成功') + '</span>';
        break;
      case invoiceCheckStatus.checkFailed:
      case invoiceCheckStatus.checkFailed + '':
        rel = '<span class="document-mark error">' + $t('验真失败') + '</span>';
        break;

      case invoiceCheckStatus.checking:
      case invoiceCheckStatus.checking + '':
        rel = '<span class="document-mark primary">' + $t('验真中') + '</span>';
        break;

      default:
      case invoiceCheckStatus.notCheck:
      case invoiceCheckStatus.notCheck + '':
        rel = '<span class="document-mark">' + $t('待验真') + '</span>';
        break;
    }
    return rel;
  },

  /** 格式化  验签状态
   * @param  value 验真状态
   * @param  $t i10n国际化对象
   */
  formatCheckSignStatus(value, $t) {
    if (!value) return '';
    var rel = '<span class="document-mark primary">' + $t('无法验签') + '</span>';
    switch (value) {
      case SignFlag.NOT_SIGN:
        rel = '<span class="document-mark error">' + $t('无法验签') + '</span>';
        break;
      case SignFlag.SIGNING:
        rel = '<span class="document-mark primary">' + $t('验签中') + '</span>';
        break;

      case SignFlag.SIGN_SUCCESS:
        rel = '<span class="document-mark success">' + $t('验签成功') + '</span>';
        break;
      case SignFlag.SIGN_FAIL:
        rel = '<span class="document-mark error">' + $t('验签失败') + '</span>';
      default:
        break;
    }
    return rel;
  },

  /** 格式化  报销状态
   * @param  value 报销状态
   * @param  $t i10n国际化对象
   */
  formatReimbursementStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceReimbursementStatus.reimbursement + '':
        rel = '<span class="document-mark success">' + $t('已报销') + '</span>';
        break;
      case invoiceReimbursementStatus.reimbursementing + '':
        rel = '<span class="document-mark primary">' + $t('报销中') + '</span>';
        break;
      case invoiceReimbursementStatus.returned + '':
        rel = '<span class="document-mark error">' + $t('已退回') + '</span>';
        break;
      case invoiceReimbursementStatus.notReimbursement:
      default:
        rel = '<span class="document-mark">' + $t('未报销') + '</span>';
        break;
    }
    return rel;
  },
  /** 格式化  占用状态（同一张发票若已人上传使用，其他人再上传时显示已占用）
   * @param  value 报销状态
   * @param  $t i10n国际化对象
   */
  formatUsedStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceUsedStatus.notUniqueFlag + '':
        let sourceName = companySource()
        rel = '<span class="document-mark error">' + $t(sourceName == 'futureland' ? '已采集' : '已占用') + '</span>';
        break;
    }
    return rel;
  },
  /** 格式化  作废
   * @param  value 作废状态
   * @param  $t i10n国际化对象
   */
  formatInvoiceFlag(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceFlag.invalid + '':
        // console.log('invoiceFlag',invoiceFlag)
        rel = '<span class="document-mark error">' + $t('已作废') + '</span>';
        break;
    }
    return rel;
  },
  /** 格式化  作废
   * @param  value 作废状态
   * @param  $t i10n国际化对象
   */
  formatRedFlag(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case redFlag.red + '':
        // console.log('invoiceFlag',invoiceFlag)
        rel = '<span class="document-mark error">' + $t('已红冲') + '</span>';
        break;
    }
    return rel;
  },
  /** 格式化  抬头维护状态（目前神华专用，抬头如果没有在系统里维护提示抬头未维护）
   * @param  value 报销状态
   * @param  $t i10n国际化对象
   */
  formatHasTitle(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceHasTitle.notHasTitle + '':
        rel = '<span class="document-mark error">' + $t('抬头未维护') + '</span>';
        break;
    }
    return rel;
  },
  formatSignFlag(value) {
    const signMap = {
      '-1': '未验签',
      '0': '验签中',
      '1': '验签成功',
      '2': '验签失败',
    };
    const status = signMap[value] || false;
    console.log(status, value);
    return status ? `<span class="document-mark">${status}</span>` : '';
  },
  /** 格式化  销项发票开具状态
   * @param  value 销项发票开具状态
   * @param  $t i10n国际化对象
   */
  formatInvoiceStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceStatus.finished:
        rel = '<span class="document-mark success">' + $t('已完成') + '</span>';
        break;
      case invoiceStatus.unfinished:
        rel = '<span class="document-mark error">' + $t('开票中') + '</span>';
        break;
      default:
        rel = '<span class="document-mark error">' + $t('开票中') + '</span>';
        break;
    }
    return rel;
  },
  /** 格式化  抽取状态
   * @param  value 抽取状态
   * @param  $t i10n国际化对象
   */
  formatExtractStatus(value, $t) {
    if (!value) return '';
    var rel = '';
    switch (value) {
      case invoiceExtractStatus.ExtractSuccess:
        rel = '<span class="document-mark success">' + $t('已入库') + '</span>';
        break;
      case invoiceExtractStatus.notExtract:
      default:
        rel = '<span class="document-mark">' + $t('未入库') + '</span>';
        break;
    }
    return rel;
  },
  /**格式化 文档类型 简称
   * @param  docmentType 文档类型编号
   * @param  $t i10n国际化对象
   */
  formatDocumentShortName(docmentType, $t) {
    if (!docmentType) return '';
    var rel = '<span class="document-mark warning">';
    switch (docmentType) {
      case '10001001':
        rel += '专';
        break;
      case '20001001':
      case '20001002':
        rel += '普';
        break;
      case '10':
        rel += '多';
        break;
      case '30001001':
        rel += '电';
        break;
      case '30001002':
        rel += '行';
        break;
      case '40001001':
        rel += '卷';
        break;

      case '50001001':
        rel += '机';
        break;

      case '50001009':
        rel += '飞';
        break;

      case '50001010':
        rel += '火';
        break;
      case '50001011':
        rel += '交';
        break;
      case '50001012':
        rel += '信';
        break;

      case '50001013':
        rel += '定';
        break;
      default:
        rel = '';
        break;
    }
    rel += '</span>';
    return rel;
  },

  /**格式化 发票类型 简称
   * @param  invoiceType 发票类型编号
   * @param  $t i10n国际化对象
   */
  formatInvoiceTypeShortName(invoiceType, $t) {
    if (!invoiceType) return '';
    var rel = '<span class="document-mark normal">';
    switch (invoiceType) {
      case 's':
        rel += '专';
        break;
      case 'c':
        rel += '普';
        break;
      case 'ce':
        rel += '电';
        break;
      case 'ju':
        rel += '卷';
        break;

      case 'v':
        rel += '机';
        break;
      default:
        rel = '';
        break;
    }
    rel += '</span>';
    return rel;
  },
  /**
   * 发票是否有影像
   */
  formatHasImgUrl(imgUrl, $t) {
    if (!!imgUrl) {
      return `<span class="document-mark normal">图</span>`;
    } else {
      return `<span class="document-mark error">无</span>`;
    }
  },
  /**
   * 是否同步
   */
  formatExtractFlag(extractFlag, $t){
    const flag = {
      '1': '已同步业务系统',
      '0': '未同步业务系统'
    }
    return `<span class="document-mark ${+extractFlag?'success':'normal'}">${flag[extractFlag]}</span>`
  }
};
